import React from 'react'
import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material'

const slotPropsSmall = { typography: { variant: 'caption' } } as const

const CheckBox = ({
	label,
	disabled,
	defaultValue = false,
	id,
	onChange,
	small,
}: {
	label: string
	disabled?: boolean
	defaultValue?: boolean
	id?: string
	onChange?: (nextValue: boolean, id?: string) => void
	small?: boolean
}): JSX.Element => {
	const [checked, setChecked] = React.useState(Boolean(defaultValue))

	React.useEffect(() => {
		setChecked(Boolean(defaultValue))
	}, [defaultValue])

	const handleChange = React.useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const nextValue = event.target.checked
			setChecked(nextValue)
			onChange?.(nextValue, id)
		},
		[id, onChange]
	)

	const control = React.useMemo(
		() => (
			<MuiCheckbox
				checked={checked}
				onChange={handleChange}
				disabled={disabled}
				size={small ? 'small' : 'medium'}
			/>
		),
		[checked, disabled, handleChange, small]
	)

	return (
		<FormControlLabel
			control={control}
			label={label}
			slotProps={small ? slotPropsSmall : undefined}
		/>
	)
}

export default CheckBox
